export default __webpack_public_path__ + "static/media/google-video.9eecc689.jpg";